

import axios from "axios";

const BASE_URL = "";

export const getVenuePlannerData = async () => {
  const response = await axios.get(
    `${BASE_URL}/api/venue-planner/`
  );

  return response.data;
};